/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import { Form, Modal, Button, Typography, Row, Col, message, Tooltip, Image, List, Empty, DatePicker, Input, Select } from "antd";
import { documentAction } from "../../DocumentSection/state/actions";

import { PropertySearch } from "../../DocumentSection/components/PropertySearch";
import moment from "moment";
import "../../DocumentSection/style/DocumentForm.css";
import style from "../../DocumentSection/style/DocumentSection.module.css";
import { SearchOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { PriceInput } from "../../DocumentSection/components/PriceInput";
import { defaultERTSData } from "../../Common/commondata/commonData";
import houseImage from "../../Assets/imagePlaceholder.webp";
import { useMediaQuery } from "react-responsive";
import { useLocation, useHistory } from "react-router-dom";
import { v4 } from "uuid";
import DelegateUser from "../../DocumentSection/components/DelegateUser";

import { combineAgentWithComma } from "../../Common/commondata/commonData";
import DocSet from "../../DocumentSection/components/DocSet";

import { AddSeller } from "./AddSeller";
import { CreateERTS } from "./CreateERTS";

import { ImportErts } from "../../DocumentSection/components/ImportErts";
import { getFullNamesFromArray, prepareAgent } from "../../DocumentSection/utils/helper";
import { buildPropertyFullAddress, combineBrokersFirmName,} from "../../Common/utils/extraFunctions";
import { clientAction } from "../../Client/state/actions";
import { ERTSAction } from "../state/action";
import { lib } from "crypto-js";
import DelegateSeller from "../../DocumentSection/components/DelegateSeller";

const { Text } = Typography;
function validateMessages(label) {
  return {
    required: `${label} is required!`,
    types: {
      email: `${label} is not a valid email!`,
      number: `${label} is not a valid number!`,
    },
  };
}

function ErtsForm({ setListingModalFields, fieldEmpty, setFieldIsEmpty, listingModalFields, optionalIds, setOptionalIds, source, progress, setProgress, redirectFromClient, delegate, form, handlePropSearchModel, handleCancelErts, manualListingModal, addPersons, addCorps, setAddPerson, setAddCorps, file, setFile, setFileNametext, ertsType, setErtsType, state, setState, confirmModal, setconfirmModal }) {
  const dispatch = useDispatch();
  let history = useHistory();
  const { CurrentPdfImportData, urlImportData } = useSelector((state) => state.documentSection.urlImportReducer);
  const { getLicenseData } = useSelector((state) => state.account);

  const disabledDate = (current) => {
    const targetDate = moment(listingModalFields?.startPeriod, "YYYY-MM-DD");
    const nextDay = targetDate.clone().add(1, "day");
    return current && current.isBefore(nextDay, "day");
  };
  const defaultStartDate = moment();

  const { pathname } = useLocation();
  const location = useLocation();

  const { formFields, setFormFields } = redirectFromClient;

  const { getCategoryData } = useSelector((state) => state.documentSection.categoryReducer, shallowEqual);

  const [isownerDetailModal, setisownerDetailModal] = useState(false);

  const isMobile = useMediaQuery({ maxWidth: 480 });
  const isTab = useMediaQuery({ maxWidth: 950 });


  const redirectFunc = (propertyId) => {
    history.push({
      pathname,
      state: {
        category: "SELLER",
        categoryId: propertyId,
        // categoryId: ('6660203e8b3d668bf3d68747')
      },
    });
  };
  let { ownwersData, ownwersDataLoading } = useSelector((state) => state.documentSection.PropertySearchReducer);

  let { clientsArray, currentlySelectedCorpData, isCorpTrue, sellerIds } = useSelector((state) => state.documentSection.CorpReducer);

  useEffect(() => {
    if (getLicenseData?.length > 0) {
      for (let i = 0; i < getLicenseData?.length; i++) {
        if (getLicenseData[i].idType === "COLORADO STATE LICENSE") {
          setBrokerLicenseId(getLicenseData[i]?.id?.toUpperCase());
        }
      }
    }
  }, [getLicenseData]);

  useEffect(() => {
    if (getCategoryData?.length && redirectFromClient.isOfferModal) {
      redirectFromClient.form.setFieldsValue({ propertyType: formFields?.name });
    }
  }, [redirectFromClient.isOfferModal, formFields, getCategoryData, redirectFromClient.form]);

  const { onFocusData } = useSelector((state) => state.documentSection.onFocusReducer, shallowEqual);

  // In this useEfffect we are setting up the progress percentage based on filed values are filled or not
  useEffect(() => {
    const progressField = delegate
      ? ["ertsType", "priceType", "propertyType", "delegateSeller"]
      : ["ertsType", "priceType", "propertyType"];
  
    const totalSteps = progressField.length;
    let completedSteps = 0;
  
    progressField.forEach((field) => {
      const rawValue = listingModalFields?.[field] ?? fieldEmpty?.[field];
      const value = typeof rawValue === "string" ? rawValue.trim() : rawValue;
  
      if (field === "priceType" && value === "N/A") return;
  
      if (value !== undefined && value !== null && value !== "") {
        completedSteps += 1;
      }
    });
  
    let percent = Math.min(100, Math.round((completedSteps / totalSteps) * 100));
  
    // Additional validation: don't allow 100% if required listingModalFields are incomplete
    const mandatoryFields = [
      "StreetName",
      "StreetNumber",
      "City",
      "State",
      "ZipCode",
      "startPeriod",
      "endPeriod",
    ];
  
    const hasEmptyMandatoryField = mandatoryFields.some((field) => {
      const value = listingModalFields?.[field];
      return !value || (typeof value === "string" && value.trim() === "");
    });
  
    if (percent === 100 && hasEmptyMandatoryField) {
      percent = 90; // Or whatever value you'd like to cap it at
    }
  
    setProgress(percent);
  }, [fieldEmpty, listingModalFields, delegate]);
  

  function onChange(value, key) {
    const fieldEmptyUpdated = listingModalFields;
    // if (key === "delegateSeller" && (!value || (typeof value === "object" && !Object.keys(value).length))) {
    //   setOptionalIds({ documentSetId: null, templateId: null });
    //   redirectFromClient?.form?.setFieldsValue({
    //     template: "",
    //     documentSet: "",
    //   });
    // }
    fieldEmptyUpdated[key] = value;
    setListingModalFields({ ...fieldEmptyUpdated });
  }

  function onPriceChange(value, key) {
    const fieldEmptyUpdated = fieldEmpty;
    fieldEmptyUpdated[key] = value;
    setFieldIsEmpty({ ...fieldEmptyUpdated });
  }

  let handleForm = (event) => {};

  let handleOnfocusChange = (valueObj) => {
    dispatch(documentAction.onFocusData(valueObj));
  };
  let handleOnBlurChange = (object) => {
    dispatch(documentAction.onFocusData(object));
  };

  let handleOkPropertySearch = () => {
    // setManualPropertyModal(false);
  };

  let handleCancelPropertySearch = () => {
    setState((prev) => ({ ...prev, propertySearch: false }));
    //  (false);
    dispatch(documentAction.onBackbuttonClick());
    // setOfferCheck(!offercheck);
  };
  
  const delegateSeller = listingModalFields?.delegateSeller;

  const { getUserDetailsData } = useSelector((state) => state.account);
  const [brokerLicenseId, setBrokerLicenseId] = useState("");
  
  const validateClientsArray = (clientsArray) => {
    if (!Array.isArray(clientsArray) || clientsArray.length === 0) {
      message.error("Please add at least one seller.");
      return false;
    }
  
    const hasAtLeastOneValidSeller = clientsArray.some((client) => {
      if (client.isCorp) {
        return Array.isArray(client.signers) && client.signers.length > 0;
      }
      return true;
    });
  
    if (!hasAtLeastOneValidSeller) {
      message.error("Please add at least one seller.");
      return false;
    }
  
    for (const client of clientsArray) {
      if (client.isCorp && (!client.signers || client.signers.length === 0)) {
        message.error(`Some corporations do not have assigned signers. Please add signers to proceed.`);
        return false;
      }
    }
  
    return true;
  };
  
  const handleUploadDocument =  () => {
    let { StreetName = "", StreetNumber = "", City = "", State = "", DirPrefix = "", DirSuffix = "", ZipCode = "", UnitLabel = "", UnitNumber = "",  startPeriod, endPeriod, StreetSuffix = "" } = listingModalFields || {};
    let {priceType = ""}=fieldEmpty
    if (!validateClientsArray(clientsArray)) return;
    const transactionData = {
      ...CurrentPdfImportData,
      contractId: ertsType?.contractId || "66aa0f8695a14f0a36fc6e12", // new ERTS 2024
      contractType: ertsType.contractType || "ERTS",

      Sellers: clientsArray || [],
      StreetName,
      StreetNumber,
      DirPrefix,
      DirSuffix,
      StreetSuffix,
      UnitNumber,
      UnitLabel,
      City,
      State,
      ZipCode: Number(ZipCode) || "",

      PurchasePrice: priceType,
      ListingPeriodBeginDate: startPeriod,
      ListingPeriodEndByDate: endPeriod,
      // ...(delegate ? { delegateOwnerId:  delegateSeller?.id  } : {}),
    };
    
    dispatch(ERTSAction.uploadERTSFile({ file, createErts: true, ...(delegate ? { delegateOwnerId: delegateSeller?.id } : {}), ...(optionalIds?.documentSetId ? { documentSetId: optionalIds?.documentSetId } : {}), transactionData, setconfirmModal, handleCancelErts, delegate, redirectFunc }));
    dispatch(documentAction.setCorpState({ clientsArray: [] }));
    setFileNametext({});
    setFile({});
    setListingModalFields({
      ...defaultERTSData({ moment }),
    });
    setState({ importErts: false, propertySearch: false,manualEntry:true });
  };


  const handleBuildDocument = () => {
    
    let { StreetName = "", StreetNumber = "", City = "", State = "", DirPrefix = "", DirSuffix = "", ZipCode = "", UnitLabel = "", UnitNumber = "",  startPeriod, endPeriod, StreetSuffix = "",pdfData } = listingModalFields || {};
    let {priceType = ""}=fieldEmpty
   
    
    const { officeDetails, agents: SellerAgents } = prepareAgent({ delegate, delegateAgent: delegateSeller, getUserDetailsData, brokerLicenseId });

    const fullAddress = buildPropertyFullAddress(listingModalFields);

    const buildData = {
      openForPropertyDoc: "SELLER_AGENT",
      ...(delegate && { delegateOwnerId: delegateSeller?.id }),
      contractType: ertsType.contractType || "ERTS",
      token: localStorage.getItem("userAuth"),
      RTDInitiator: "SELLER",
      openFor: "SELLER_AGENT",
      contractId: ertsType?.contractId || "66aa0f8695a14f0a36fc6e12", // New ERTS 2024
      builtForSection: "DOCUMENT",
      builtForId: delegate ? delegateSeller?.id : getUserDetailsData?._id,
      ...(fieldEmpty?.property?.thirdpartyId && {
        mlsLinkedThirdpartyId: fieldEmpty.property.thirdpartyId,
      }),
      ...(fieldEmpty?.property?.propertyId && {
        mlsLinkedPropertyId: fieldEmpty.property.propertyId,
      }),
      key: delegate ? delegateSeller?.id : getUserDetailsData?._id,
      signable: true,
      ...(optionalIds?.documentSetId ? { documentSetId: optionalIds?.documentSetId } : {}),
      urlData: {
        StreetName,
        StreetNumber,
        DirPrefix,
        DirSuffix,
        StreetSuffix,
        UnitNumber,
        UnitLabel,
        City,
        State,
        ZipCode: Number(ZipCode) || "",
        FullAddress: fullAddress,
        Sellers: clientsArray || [],
        PurchasePrice: priceType,
        ListingPeriodBeginDate: startPeriod,
        ListingPeriodEndByDate: endPeriod,
        SellerAgents,
        SellerBrokersList: getFullNamesFromArray(SellerAgents),
        SellerBrokersFirmList: combineBrokersFirmName(SellerAgents),
        officeDetails,

        CountyOrParish: pdfData?.CountyOrParish || "",
        // parcelNumber: pdfData?.parcelNumber || "",
        EarnestMoneyHeldBy: pdfData?.earnestMoneyHolder || "",
        TaxLegalDescription: pdfData?.legalDescription || "",
        ParkingFacilities: pdfData?.ParkingFacilities || "",
        StorageFacilities: pdfData?.StorageFacilities || "",
        GarageRemotesIncluded: pdfData?.GarageRemotesIncluded || "",
        InclusionsAttached: pdfData?.InclusionsAttached || "",
        OtherInclusions: pdfData?.OtherInclusions || "",
        EncumberedInclusions: pdfData?.EncumberedInclusions || "",
        LeasedItems: pdfData?.LeasedItems || "",
        Exclusions: pdfData?.Exclusions || "",
        DeededWaterRightsChecked: pdfData?.DeededWaterRightsChecked || "",
        DeededWaterRightsLegalDescription: pdfData?.DeededWaterRightsLegalDescription || "",
        DeededWaterRightsDeedType: pdfData?.DeededWaterRightsDeedType || "",
        OtherRightsRelatingToWaterChecked: pdfData?.OtherRightsRelatingToWaterChecked || "",
        OtherRightsRelatingToWaterDescription: pdfData?.OtherRightsRelatingToWaterDescription || "",
        WellRightsChecked: pdfData?.WellRightsChecked || "",
        WellPermitNumber: pdfData?.WellPermitNumber || "",
        WaterStockCertificatesChecked: pdfData?.WaterStockCertificatesChecked || "",
        WaterStockCertificatesDescription: pdfData?.WaterStockCertificatesDescription || "",
        AdditionalProvisions: pdfData?.AdditionalProvisions || "",
        TitleConveyedBy: pdfData?.TitleConveyedBy || "",
        TitleConveyedBy__Other: pdfData?.TitleConveyedBy__Other || "",
        AssociationFeeNoUnpaidExcept: pdfData?.AssociationFeeNoUnpaidExcept || "",
        SellerIsForeignPersonChecked: pdfData?.SellerIsForeignPersonChecked || "",
        EarnestMoney: pdfData?.EarnestMoney || "",
        EarnestMoneyForm: pdfData?.EarnestMoneyForm || "",
        GrowingCropsDescription: pdfData?.GrowingCropsDescription || "",
        ListingElectronicNoticeAdditionalOption: pdfData?.ListingElectronicNoticeAdditionalOption || "",
       },
    };

    dispatch(clientAction.draftDocumentUlShortning(buildData, location?.pathname));
  };
  const PriceComponent = (price, type) => {
    if (!price) {
      return "";
    }
    const formattedPrice = price.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
    return formattedPrice;
  };

  const handleCloseOwnerModal = () => {
    setisownerDetailModal(false);
  };

  const CustomEmptyMessage = () => <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<span style={{ fontWeight: "bold", fontSize: "20px", color: "grey" }}>Sorry, we couldn't find owner information for that property. Please enter Seller information on the form manually.</span>} />;

  const handleOneOwnersSelected = (item) => {
    let selectedOwnerId = item?._id;
    const isCompany = item?.OwnerTypeDescription1?.toLowerCase() === "company";
    let sellerIds = [];
    item.Owners.forEach((name) => {
      sellerIds.push({
        fullName: name,
        personId: null,
        isCorp: isCompany,
        signers: [],
        key: v4(),
      });
    });
    setFieldIsEmpty({
      ...fieldEmpty,
      property: {
        ...fieldEmpty.property,
        legalDescription: fieldEmpty?.property?.legalDescription || item?.TaxLegalDescription || "",
        sellerIds,
        ...(selectedOwnerId && { selectedOwnerId }),
      },
    });

    dispatch(documentAction.setCorpState({ clientsArray: sellerIds }));
    // dispatch(documentAction.setCorpState({sellerIds}));
    handleCloseOwnerModal();
  };
  const selectOptions = [
    { value: "", label: "None" },
    { value: "East", label: "East" },
    { value: "West", label: "West" },
    { value: "North", label: "North" },
    { value: "South", label: "South" },
    { value: "Northeast", label: "North East" },
    { value: "Northwest", label: "North West" },
    { value: "Southeast", label: "South East" },
    { value: "Southwest", label: "South West" },
  ];

  return (
    <>
   
      {/* Property search modal  */}
      {state?.propertySearch && (
        <Modal width={isMobile ? "100%" : isTab ? "60%" : "50%"} style={{ marginTop: "-80px" }} visible={state?.propertySearch} onOk={handleOkPropertySearch} onCancel={handleCancelPropertySearch} footer={null} afterClose={() => dispatch(documentAction.clearFormProperty("resetForm"))}>
          <PropertySearch source={source} handleCancelPropertySearch={handleCancelPropertySearch} fieldEmpty={fieldEmpty} setFieldIsEmpty={setFieldIsEmpty} setisownerDetailModal={setisownerDetailModal} redirectFromClient={redirectFromClient} setListingModalFields={setListingModalFields}   />
        </Modal>
      )}
      {/* {state?.importErts && (
        <Modal
          width={isMobile ? "100%" : isTab ? "60%" : "50%"}
          style={{ marginTop: "-80px" }}
          visible={state?.openImportErts}
          onOk={handleOkPropertySearch}
          onCancel={() => {
            setState((prev) => ({ ...prev, openImportErts: false }));
          }}
          footer={null}
          afterClose={() => dispatch(documentAction.clearFormProperty("resetForm"))}
        >
          <ImportErts openImportErts={state?.openImportErts} file={file} setFile={setFile} fileNametext={fileNametext} setFileNametext={setFileNametext} uploadTemp={uploadTemp} state={state} setState={setState}/>
        </Modal>
      )} */}
      {/* owner Details Modal */}
      <Modal open={isownerDetailModal} footer={false} style={{ marginTop: "-50px" }} title={<p style={{ display: "flex", justifyContent: "center" }}>PLEASE SELECT VALID OWNER</p>} onCancel={handleCloseOwnerModal} maskClosable={false} closable={false}>
        <div style={{ height: "500px", overflow: "hidden", overflowY: "auto" }}>
          <List
            dataSource={ownwersData}
            loading={ownwersDataLoading}
            renderItem={(item) => (
              <List.Item className={style.listItem}>
                <div onClick={() => handleOneOwnersSelected(item)} style={{ lineHeight: "17px", padding: "5px" }}>
                  <p style={{ fontWeight: "bold" }}>{item?.PropertyAddressFull}</p>
                  <p style={{ display: "flex", flexDirection: "column" }}>
                    {item?.Owners?.map((name) => (
                      <>
                        <span style={{ fontSize: "25px" }}>&#x2022;</span>
                        <span style={{ marginLeft: "15px", marginTop: "-15px" }}>{name}</span>
                      </>
                    ))}
                  </p>
                </div>
              </List.Item>
            )}
            locale={{ emptyText: <CustomEmptyMessage /> }}
          />
        </div>
        <div style={{ textAlign: "center" }}>
          <Button onClick={handleCloseOwnerModal} type="primary">
            Cancel
          </Button>
        </div>
      </Modal>

      {/* property details box */}
      {fieldEmpty?.property?.propertyType && (
        <>
          <div className={style.box}>
            <div className={style.addressHeading}>{fieldEmpty?.property?.fullAddress}</div>
            <div className={style.boxContent} style={{ display: "flex" }}>
              <div className={style.imgBox}>
                <Image src={typeof fieldEmpty?.property?.propertyImages?.[0]?.imageUrl == "string" && fieldEmpty?.property?.propertyImages?.[0]?.imageUrl !== "" ? fieldEmpty?.property?.propertyImages?.[0]?.imageUrl : houseImage} alt="home" />{" "}
              </div>
              <div className={style.addressbox}>
                {fieldEmpty?.property?.SellerAgents?.length ? (
                  <p>
                    <Text style={{ width: "200px", fontWeight: 500, color: "#2976be" }} ellipsis>
                      <span>Agents: </span> {combineAgentWithComma({ agents: fieldEmpty?.property?.SellerAgents })}{" "}
                    </Text>
                  </p>
                ) : null}
                {fieldEmpty?.property?.listingId ? (
                  <p>
                    <span>Listing Id: </span>
                    {fieldEmpty.property.listingId}
                  </p>
                ) : null}

                {fieldEmpty?.property?.listingPrice ? (
                  <p>
                    <span>Price: </span>
                    {fieldEmpty?.property?.propertyType?.[0] === "PRIVATE" && fieldEmpty?.property?.listingPrice ? "$" : ""}
                    {PriceComponent(fieldEmpty?.property?.listingPrice, fieldEmpty?.property?.propertyType[0])}
                  </p>
                ) : null}

                {fieldEmpty?.property?.propertyType?.length > 0 ? (
                  <p>
                    <span>Source: </span>
                    {fieldEmpty?.property?.propertyType?.[0] === "PRIVATE" ? "RE-Sure" : fieldEmpty?.property?.propertyType?.[0] === "RECOLORADO" ? "REcolorado" : fieldEmpty?.property?.propertyType?.[0]}
                  </p>
                ) : null}

                {fieldEmpty?.property?.PropertyFor ? (
                  <p>
                    <span>Property Type: </span>
                    {fieldEmpty.property.PropertyFor}
                  </p>
                ) : null}

                {fieldEmpty?.property?.listingStatus ? (
                  <p>
                    <span>Status: </span>
                    {fieldEmpty?.property?.listingStatus}
                  </p>
                ) : null}
              </div>
              {fieldEmpty?.property?.sellerIds && fieldEmpty?.property?.sellerIds?.length > 0 && (
                <>
                  <div style={{ border: "1px solid #2976be" }}></div>
                  <div className={style.addressbox}>
                    <p style={{ fontSize: "17px", fontWeight: "bold" }}>Property Owners:</p>
                    {fieldEmpty?.property?.sellerIds &&
                      fieldEmpty?.property?.sellerIds?.map((el, index) => (
                        <Tooltip title={el?.fullName?.trim()} key={index}>
                          <p className={style.ownerNames}>
                            {index + 1}. {el?.fullName?.trim()}
                          </p>
                        </Tooltip>
                      ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}

      {state?.ReImportErts ? (
        <Button
          onClick={() => {
            Modal.confirm({
              title:<div style={{marginBottom:"10px"}}>Are you sure you want to import again? This action will also overwrite the existing document data.</div>,
              okText: "Yes",
              cancelText: "No",
              onOk: () => {
                setState((prev) => ({
                  ...prev,
                  importErts: true,
                }));
                setFile({});
                setFileNametext({});
              },
            });
          }}
          style={{ marginTop: "20px" }}
          type="primary"
        >
          Import
        </Button>
      ) : (
        <Button onClick={handlePropSearchModel} style={{ marginTop: "20px" }} type="primary">
          Property Search <SearchOutlined style={{ fontSize: "16px", marginLeft: "5px" }} />
        </Button>
      )}

      <Form className="formaccnt" form={form} layout="vertical" validateMessages={validateMessages} style={{ marginTop: "20px" }} scrollToFirstError onFinish={handleForm} initialValues={{ UnitLabel: "Unit" }}>
        {/* Conditional Property Type Label Row */}
        {fieldEmpty?.property?.propertyType && (
          <Row gutter={16}>
            <Col xs={24}>
              <div style={{ marginBottom: "1rem" }}></div>
            </Col>
          </Row>
        )}

        {delegate && (
               <>
                 <DelegateSeller setListingModalFields={setListingModalFields} onChange={onChange} selectedSellerAgent={listingModalFields?.delegateSeller?listingModalFields?.delegateSeller:null} />
                 <hr style={{ marginTop: "30px" }} />
               </>
             )}

        {/* Property Type & Template */}
        <Row gutter={16}>
          <CreateERTS setErtsType={setErtsType} delegate={delegate} listingModalFields={listingModalFields} />
          <DocSet handleOnfocusChange={handleOnfocusChange} optionalIds={optionalIds} setOptionalIds={setOptionalIds} fieldEmpty={fieldEmpty} delegate={delegate} listingModalFields={listingModalFields} source={"Listing"}/>
        </Row>

        {/* Price & Document Set */}
        <Row gutter={16}>
          <PriceInput handleOnfocusChange={handleOnfocusChange} handleOnBlurChange={handleOnBlurChange} fieldEmpty={fieldEmpty} onPriceChange={onPriceChange} />
          <AddSeller delegate={delegate} addPersons={addPersons} addCorps={addCorps} setAddPerson={setAddPerson} setAddCorps={setAddCorps} listingModalFields={listingModalFields} setListingModalFields={setListingModalFields}/>
        </Row>

        {/* Listing Dates */}
        <Row gutter={16}>
          <Col xs={24} sm={24} md={12}>
            <Form.Item className="lbl" name="startPeriod" label="Listing Start Date" rules={[{ required: true, message: "Please select the Listing Start Date." }]}>
              <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} allowClear defaultValue={defaultStartDate} onChange={(e, value) => onChange(value, "startPeriod")} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item className="lbl" name="endPeriod" label="Listing End Date" rules={[{ required: true, message: "Please select the Listing End Date." }]} initialValue={listingModalFields?.endPeriod ? moment(listingModalFields?.endPeriod, "YYYY-MM-DD") : null}>
              <DatePicker
                format="YYYY-MM-DD"
                style={{ width: "100%" }}
                allowClear
                // disabled={!listingModalFields?.startPeriod}
                disabledDate={disabledDate}
                defaultValue={listingModalFields?.endPeriod ? moment(listingModalFields.endPeriod, "YYYY-MM-DD") : null}
                onChange={(e, value) => onChange(value, "endPeriod")}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Address Fields */}
        <Row gutter={16}>
          <Col md={12}>
            <Form.Item name="StreetNumber" label="Street Number" className="lbl" rules={[{ required: true, message: "Please enter the Street Number." }]} initialValue={listingModalFields?.StreetNumber || ""}>
              <Input allowClear type="number" onChange={(e) => onChange(e.target.value, "StreetNumber")} placeholder="Enter Street Number" />
            </Form.Item>
          </Col>
          <Col md={12}>
            <Form.Item name="DirPrefix" label="Direction Prefix" className="lbl" initialValue={listingModalFields?.DirPrefix || undefined}>
              <Select placeholder="Select Direction Prefix" options={selectOptions} allowClear onChange={(e) => onChange(e, "DirPrefix")} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col md={12}>
            <Form.Item name="StreetName" label="Street Name" className="lbl" rules={[{ required: true, message: "Please enter the Street Name." }]}>
              <Input placeholder="Enter Street Name" onChange={(e) => onChange(e.target.value, "StreetName")} initialValue={listingModalFields?.StreetName || ""} allowClear />
            </Form.Item>
          </Col>
          <Col md={12}>
            <Form.Item name="StreetSuffix" label="Street Suffix" className="lbl" initialValue={listingModalFields?.StreetSuffix || ""}>
              <Input placeholder="Enter Street Suffix" onChange={(e) => onChange(e.target.value, "StreetSuffix")} allowClear />
            </Form.Item>
          </Col>
        </Row>

        {/* Unit Label & Number */}
        <Row gutter={16}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="DirSuffix" label="Direction Suffix" className="lbl" initialValue={listingModalFields?.DirSuffix || undefined}>
              <Select placeholder="Select Direction Suffix" options={selectOptions} allowClear onChange={(e) => onChange(e, "DirSuffix")} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <Form.Item
                label="Unit Label"
                name="UnitLabel"
                className="lbl"
                initialValue={listingModalFields?.UnitLabel || ""}
                style={{
                  flex: 1,
                }}
              >
                <Input
                  placeholder="Enter Unit, Apt or Suite"
                  onChange={(e) => {
                    onChange(e.target.value, "UnitLabel");
                  }}
                  allowClear
                />
              </Form.Item>
              <Form.Item
                label="Unit Number"
                name="UnitNumber"
                style={{
                  flex: 1,
                }}
              >
                <Input
                  placeholder="Enter Unit Number"
                  onChange={(e) => {
                    onChange(e.target.value, "UnitNumber");
                  }}
                  allowClear
                />
              </Form.Item>
            </div>
          </Col>
        </Row>

        {/* City, State, Zip */}
        <Row gutter={16}>
          <Col md={12}>
            <Form.Item className="lbl" name="City" label="City" rules={[{ required: true, message: "Please enter the City." }]} initialValue={listingModalFields?.City || ""}>
              <Input onChange={(e) => onChange(e.target.value, "City")} placeholder="Enter City" allowClear />
            </Form.Item>
          </Col>
          <Col md={12}>
            <Form.Item className="lbl" name="State" label="State" rules={[{ required: true, message: "Please enter the State." }]} initialValue={listingModalFields?.State || ""}>
              <Input placeholder="Enter State" onChange={(e) => onChange(e.target.value, "State")} allowClear />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col md={12}>
            <Form.Item
              className="lbl"
              name="ZipCode"
              label="Zip Code"
              rules={[
                { required: true, message: "" },
                { whitespace: true },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (value?.length > 4 && value?.length < 7) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Please enter a valid Zip Code."));
                  },
                }),
              ]}
              hasFeedback
              initialValue={listingModalFields?.ZipCode || ""}
            >
              <Input type="number" maxLength={6} allowClear onChange={(e) => onChange(e.target.value, "ZipCode")} placeholder="Enter Zip Code" />
            </Form.Item>
          </Col>
        </Row>

        {/* Done Button */}
        <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <Button type="primary" onClick={Object.keys(CurrentPdfImportData).length > 0 ? handleUploadDocument : handleBuildDocument} style={{ display: "flex", justifyContent: "center" }} 
          disabled={!listingModalFields.startPeriod || !listingModalFields.endPeriod || !listingModalFields.StreetName || !listingModalFields.StreetNumber || !listingModalFields.City || !listingModalFields.State || !listingModalFields.ZipCode||(delegate&&!listingModalFields?.delegateSeller)
          ||(Object.keys(CurrentPdfImportData).length > 0 && (!clientsArray.length>0))}>
            Create
          </Button>
        </div>

        {/* OR: Use Build Button if needed */}
        {/* <Row gutter={16} align="center" style={{ marginTop: "2rem", gap: "10px" }}>
    <BuildErtsButton
      progress={progress}
      handleBuildButtonClick={handleSaveDocumentData}
      handleUploadClick={handleUploadClick}
      delegate={delegate}
    />
  </Row> */}
      </Form>
    </>
  );
}
export { ErtsForm };
